

// 翔云OCR配置
export const xiangyunKey = {
    key: "Es1TRT94hJsvSttv9GLhy4",
    secret: "19d6be2e3e164f98a1b7d1321a73189c"
}